module.exports = __webpack_public_path__ + "img/empty_avatar.442fa793.svg";